import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import ImpersonatingBanner from './ImpersonatingBanner';
import { useSidebar } from '../../context/SidebarContext';

export const DashboardLayout = ({ children }) => {
    const { collapsed } = useSidebar();

    return (
        <div className="min-h-screen" style={{ backgroundColor: '#f5f5f4' }}>
            <Sidebar />
            <div className={`main-content ${collapsed ? 'main-content-collapsed' : ''}`}>
                <ImpersonatingBanner />
                <Header />
                <main className="pt-16 md:pt-0">
                    <div className="page-container">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
